import { combineReducers } from 'redux';
import { reducers as alert } from './alerts';
import { reducers as header } from './header';
import { reducers as home } from './home';
import { reducers as globaldata } from './common/globaldata';
import { reducers as globalsearch } from './common/globalsearch';
import { reducers as mylocation } from './mylocation';
import { reducers as myhealth } from './myhealth';
import { reducers as myproductivity } from './myproductivity';
import { reducers as navigation } from './navigation';
import { reducers as fc } from './machineDetails/fc';
import { reducers as myfleet } from './myfleet';
import { reducers as mycoverage } from './mycoverage';
import { reducers as customFilterMyfleet } from './common/customFilter';
import { reducers as orderdetail } from './orderdetail';

const rootReducer = combineReducers({
    alert,
    header,
    home,
    globaldata,
    globalsearch,
    mylocation,
    myhealth,
    myproductivity,
    navigation,
    fc,
    myfleet,
    mycoverage,
    customFilterMyfleet,
    orderdetail
});

export default rootReducer;
